module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Anchor-left-up-c10deee1b5dff22acf7e86f12721c035.svg";